module.exports = __webpack_public_path__ + "img/kendeda.cc4df2f8.jpg";